module.exports = __webpack_public_path__ + "img/jiazhuangcase.8fecee52.png";